/* eslint-disable ember/no-classic-components, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class SettingManager extends Component {
  // Services
  @service
  store;

  @service
  toaster;

  event = null;

  @tracked
  name = '';

  @action
  setName(value) {
    this.name = value;
  }

  @tracked
  staffBookingManagement = false;

  @action
  setStaffBookingManagement(value) {
    this.staffBookingManagement = value;
  }

  @tracked
  consecutiveBookings = false;

  @action
  setConsecutiveBookings(value) {
    this.consecutiveBookings = value;
  }

  @tracked
  consecutiveBookingMessage = '';

  @action
  setConsecutiveBookingMessage(value) {
    this.consecutiveBookingMessage = value;
  }

  @tracked
  dialogOpen = false;

  @action
  openDialog() {
    this.name = this.event.get('name');
    this.staffBookingManagement = this.event.get('staffBookingManagement');
    // Note: silly negation
    this.consecutiveBookings = !this.event.get('consecutiveBookings');
    this.consecutiveBookingMessage = this.event.get(
      'consecutiveBookingMessage',
    );
    this.dialogOpen = true;
  }

  @action
  save() {
    this.event.setProperties({
      name: this.name,
      staffBookingManagement: this.staffBookingManagement,
      // Note: silly negation
      consecutiveBookings: !this.consecutiveBookings,
      consecutiveBookingMessage: this.consecutiveBookingMessage,
    });
    this.event
      .save()
      .then(() => {
        this.toaster.success('Event saved successfully!');
      })
      .catch(() => {
        this.toaster.error('Error saving Event!');
      })
      .finally(() => {
        this.dialogOpen = false;
      });
  }
}
